// Review comparisons use the same whole-second precision as the duration editor.
// Never write this normalised value back to a task or its tailoring payload.
export function comparisonMinutes(minutes) {
    if (typeof minutes !== "number" || !Number.isFinite(minutes)) return minutes
    return Math.round(minutes * 60) / 60
}

export function formatSeconds(minutes) {
    const seconds = Math.round(Math.abs(minutes) * 60)
    const wholeMinutes = Math.floor(seconds / 60)
    const remainder = seconds % 60
    const sign = minutes < 0 && seconds ? "-" : ""
    const minuteLabel = `${wholeMinutes} min${wholeMinutes === 1 ? "" : "s"}`
    const secondLabel = `${remainder} sec${remainder === 1 ? "" : "s"}`
    if (!wholeMinutes) return `${sign}${secondLabel}`
    if (!remainder) return `${sign}${minuteLabel}`
    return `${sign}${minuteLabel} ${secondLabel}`
}
